import { render, staticRenderFns } from "./mButton.vue?vue&type=template&id=46fedbce&scoped=true"
import script from "./mButton.vue?vue&type=script&lang=ts"
export * from "./mButton.vue?vue&type=script&lang=ts"
import style0 from "./mButton.vue?vue&type=style&index=0&id=46fedbce&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fedbce",
  null
  
)

export default component.exports